import { useState, useCallback, useEffect } from 'react';
import { Flex, Button } from 'components/ui';
import { Contract } from '@ethersproject/contracts';
import { notifyTx } from 'utils/notifications';
import { futuraChainId, isDev } from 'utils/config';

interface ApproveTokenProps {
  children: JSX.Element;
  userAddress: string;
  spendingContractAddress: string;
  tokenContract: Contract;
  approveLabel: string;
}

const ApproveMixpass = ({
  children,
  userAddress,
  spendingContractAddress,
  tokenContract,
  approveLabel,
}:ApproveTokenProps) => {
  const [isApproved, setIsApproved] = useState<boolean>(false);
  const [pending, setPending] = useState<boolean>(false);
  
  const checkApproval = useCallback(async () => {
    const approved = await tokenContract.isApprovedForAll(userAddress, spendingContractAddress);
    setIsApproved(approved);
  }, [tokenContract, userAddress, spendingContractAddress]);

  useEffect(() => {
    checkApproval();
  }, [checkApproval])

  const setApproval = useCallback(async (approval: boolean) => {
    notifyTx({
      method: () => tokenContract.setApprovalForAll(spendingContractAddress, approval),
      chainId: futuraChainId,
      success: approval ? 'Successfully approved token' : 'Approval revoked for token',
      onSuccess: () => {
        checkApproval();
        setPending(false);
      },
      onError: () => setPending(false),
      onSubmitted: () => setPending(true),
      error: 'Approval failed',
    });
  }, [tokenContract, spendingContractAddress, checkApproval]);

  return (
    <>
      {
        isApproved ? (
          <Flex>
            { children }
            {isDev() && (
              <Button disabled={pending} ml={2} onClick={() => setApproval(false)}>
                [DEV] Revoke approval
              </Button>
            )}
          </Flex>
        ) : (
          <Button disabled={pending} onClick={() => setApproval(true)}>
            { approveLabel }
          </Button>
        )
      }
    </>
  )
}

export default ApproveMixpass;
